import React from 'react';
import * as OPTIONS from '../utils/ref/formConstants';

export default ({field}) => {
  if (!field || !OPTIONS[field]) return null;
  return OPTIONS[field].map(op => (
    <option key={op} value={op}>{op}</option>
  ))
}
